import StatusPage, { StatusPageProps } from "@/containers/StatusPages";

export type NoTagsViewProps = { className?: string };
import TagIcon from "@/assets/icons/tag.svg";

const EmptyTags: React.FunctionComponent<Partial<StatusPageProps>> = (
  props
) => {
  return (
    <StatusPage
      icon={TagIcon}
      title={L.TAGS_EMPTY_TITLE}
      subtitle={L.TAGS_EMPTY_SUBTITLE}
      {...props}
    />
  );
};

export default EmptyTags;
